import { Typography, Divider } from '@mui/material';

const LocalDivider = ({ title = '', disabledDivider = false, sx = {} }) => (
  <>
    {!disabledDivider && (
      <Divider
        sx={{
          my: 2,
          height: '2px',
          borderStyle: 'none',
          background:
            'repeating-linear-gradient(90deg, rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12) 10px, transparent 10px, transparent 20px)',
          ...sx,
        }}
      />
    )}

    {title !== '' && (
      <Typography variant="h6" component="h3" align="center">
        {title}
      </Typography>
    )}
  </>
);

export default LocalDivider;
